module.exports = __webpack_public_path__ + "static/fictionGif-3502f38d0b78eb8268c7b4ce77673aa3.mp4";